import { render, staticRenderFns } from "./piediagramm.vue?vue&type=template&id=7aae530a&scoped=true&"
import script from "./piediagramm.vue?vue&type=script&lang=js&"
export * from "./piediagramm.vue?vue&type=script&lang=js&"
import style0 from "./piediagramm.vue?vue&type=style&index=0&id=7aae530a&prod&scoped=true&lang=css&"
import style1 from "./piediagramm.vue?vue&type=style&index=1&id=7aae530a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aae530a",
  null
  
)

export default component.exports